import { NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
    imports: [
        ToastrModule.forRoot({
            preventDuplicates: true,
            maxOpened: 3,
            iconClasses: {
                error: 'ngx-toast-error',
                info: 'ngx-toast-info',
                success: 'ngx-toast-success',
                warning: 'ngx-toast-warning',
            },
        })
    ]
})

export class SharedToastrModule { }


// WEBPACK FOOTER //
// ./src/app/shared/refactored/toastr.module.ts